import { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export const Unlock = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 2C11.6716 2 11 2.67157 11 3.5V6H14V16H2V6H9V3.5C9 1.567 10.567 0 12.5 0C14.433 0 16 1.567 16 3.5V4H14V3.5C14 2.67157 13.3284 2 12.5 2ZM10 10H6V12H10V10Z"
      fill="currentColor"
    />
  </svg>
);
